import React, { useMemo, useState } from 'react';
import { Empty, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import TableLoader from 'components/Sceletons/TableLoader';
import { ISubscriptionItem } from 'interfaces';
import { getSubscriptionsColumns } from './subscriptionsColumns';
import SubscriptionInfoModal from '../../modals/SubscriptionInfoModal/SubscriptionInfoModal';
import classes from './SubscriptionsTable.module.scss';

interface SubscriptionsTableProps {
  isLoading: boolean;
  data: ISubscriptionItem[];
  onSubscriptionCancel: () => void;
}

const SubscriptionsTable: React.FC<SubscriptionsTableProps> = ({
  isLoading,
  data,
  onSubscriptionCancel,
}) => {
  const { t } = useTranslation();
  const [selectedSubscription, setSelectedSubscription] = useState<ISubscriptionItem | null>(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState<boolean>(false);

  const handleOpenDetails = (record: ISubscriptionItem) => {
    setSelectedSubscription(record);
    setIsDetailsModalOpen(true);
  };

  const handleCloseDetails = () => {
    setIsDetailsModalOpen(false);
    setSelectedSubscription(null);
  };


  const columns = useMemo(
    () => getSubscriptionsColumns({ t, onOpenDetails: handleOpenDetails }),
    [t]
  );

  if (isLoading) {
    return <TableLoader />;
  }

  return (
    <div className={classes.container}>
      <div className={classes.tableWrap}>
        <Table
          dataSource={data}
          columns={columns}
          locale={{
            emptyText: (
              <Empty
                description={
                  <span>
                    {t('Billing.subscriptions.emptyState')}
                    <br />
                    <span className={classes.emptyHint}>
                      {t('Billing.subscriptions.emptyHint')}
                    </span>
                  </span>
                }
              />
            ),
          }}
          scroll={{
            y: 'calc(100vh - 155px)',
          }}
          pagination={false}
        />
      </div>

      <SubscriptionInfoModal
        subscription={selectedSubscription}
        isOpen={isDetailsModalOpen}
        onClose={handleCloseDetails}
        onSubscriptionCancelled={onSubscriptionCancel}
      />
    </div>
  );
};

export default SubscriptionsTable;


